export const endpoints = {
  production: {
    basket: 'https://basket-api.notonthehighstreet.com',
  },
  staging: {
    basket: 'https://basket-api.public.b.stag-eu-west-1.noths.com',
  },
  oldstaging: {
    basket: 'https://basket-api.public.b.prod-eu-west-1.noths.com',
  },
  qa: {
    basket: 'https://basket-api-shared.qa.noths.com',
  },
  development: {
    basket: 'https://basket-api-shared.qa.noths.com',
  },
};
